import { useEffect, useState } from 'react';
import { fechaLocalIso, formatearMonedaArs, type HonorarioMedicoDTO } from '@ausentia/shared';
import { api, ErrorApi } from '../api/cliente.js';
import { useToast } from '../componentes/Toast.js';

// Fecha local, no UTC: entre las 21:00 y las 00:00 hora Argentina, toISOString()
// devuelve mañana y el honorario recién guardado no aplicaría a las visitas de hoy.
const hoyIso = () => fechaLocalIso();

export function Honorarios() {
  const [honorarios, setHonorarios] = useState<HonorarioMedicoDTO[] | null>(null);
  const [error, setError] = useState('');

  async function refrescar() {
    try {
      setHonorarios(await api.get<HonorarioMedicoDTO[]>('/api/operador/honorarios'));
    } catch (err) {
      setError(err instanceof ErrorApi ? err.message : 'No se pudieron cargar los honorarios');
    }
  }
  useEffect(() => { void refrescar(); }, []);

  return (
    <section>
      <h2>Honorarios médicos</h2>
      <p className="muted">Monto que le pagás a cada profesional por atención. Guardar crea una nueva vigencia desde hoy.</p>
      {error && <div className="error-box" role="status">{error}</div>}
      {honorarios === null ? (
        <div className="cargando">Cargando…</div>
      ) : (
        <table className="tabla">
          <thead>
            <tr>
              <th scope="col">Profesional</th>
              <th scope="col">Honorario actual</th>
              <th scope="col">Nuevo honorario (ARS)</th>
              <th scope="col" aria-label="Acción" />
            </tr>
          </thead>
          <tbody>
            {honorarios.map((h) => (
              <FilaHonorario key={h.medicoId} honorario={h} onGuardado={refrescar} />
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}

function FilaHonorario({ honorario, onGuardado }: { honorario: HonorarioMedicoDTO; onGuardado: () => Promise<void> }) {
  const toast = useToast();
  const [pesos, setPesos] = useState('');
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState('');

  async function guardar() {
    const valor = Number(pesos);
    if (!pesos || Number.isNaN(valor) || valor < 0) {
      setError('Ingresá un monto válido');
      return;
    }
    setGuardando(true);
    setError('');
    try {
      await api.put('/api/operador/honorarios', {
        medicoId: honorario.medicoId,
        montoCentavos: Math.round(valor * 100),
        vigenteDesde: hoyIso(),
      });
      setPesos('');
      await onGuardado();
      toast.mostrar(`Honorario de ${honorario.medicoNombre} actualizado`);
    } catch (err) {
      setError(err instanceof ErrorApi ? err.message : 'No se pudo guardar');
    } finally {
      setGuardando(false);
    }
  }

  return (
    <tr>
      <td>{honorario.medicoNombre}</td>
      <td>{honorario.montoCentavos !== null ? formatearMonedaArs(honorario.montoCentavos) : <span className="insignia ambar">sin honorario</span>}</td>
      <td>
        <input
          type="number"
          min={0}
          step="0.01"
          inputMode="decimal"
          aria-label={`Nuevo honorario ${honorario.medicoNombre}`}
          value={pesos}
          onChange={(e) => setPesos(e.target.value)}
          placeholder="0,00"
        />
        {error && <p className="mini" style={{ color: 'var(--rojo)' }}>{error}</p>}
      </td>
      <td>
        <button className="secundario" style={{ width: 'auto' }} onClick={guardar} disabled={guardando}>
          {guardando ? '…' : 'Guardar'}
        </button>
      </td>
    </tr>
  );
}
